import './OkulyonetimSuccessModal.scss'

import { Modal, Table } from 'antd'
import okulSepetiPopUp from 'images/okulsepetipop-up.png'
import React, { useEffect } from 'react'

interface SuccessModalProps {
  isModalVisible: boolean
  message: string
  image: string
  title: string
  price: number
  quantity?: number
  dersler: string[]
  handleOk: () => void
}

interface DataType {
  key: string
  firstPart: string
  secondPart: string
}

function splitString(input: string): { firstPart: string; secondPart: string; thirdPart: string } {
  const [firstPart, secondPart, thirdPart] = input.split(' * ').map((part) => part.trim())
  return {
    firstPart: firstPart || '',
    secondPart: secondPart || '',
    thirdPart: thirdPart || '',
  }
}

const OkultonetimSuccessModal: React.FC<SuccessModalProps> = ({
  isModalVisible,
  message,
  dersler,
  handleOk,
  title,
  quantity,
  price,
  image,
}) => {
  // Dersler dizisini tabloya uygun hale getiriyoruz
  const data: DataType[] = dersler.map((ders, index) => {
    const { firstPart, secondPart, thirdPart } = splitString(ders)
    return {
      key: index.toString(),
      firstPart,
      secondPart,
      thirdPart,
    }
  })

  const columns = [
    {
      title: 'Sınıf',
      dataIndex: 'firstPart',
      key: 'firstPart',
    },
    {
      title: 'Ders',
      dataIndex: 'secondPart',
      key: 'secondPart',
    },
    {
      title: 'Adet',
      dataIndex: 'thirdPart',
      key: 'thirdPart',
    },
  ]

  useEffect(() => {
    if (isModalVisible) {
      const timer = setTimeout(() => {
        handleOk()
      }, 3000)

      return () => clearTimeout(timer)
    }
  }, [isModalVisible, handleOk])

  return (
    <Modal
      open={isModalVisible}
      onOk={handleOk}
      onCancel={handleOk}
      className="okul-yonetim-success-modal"
      footer={null}
    >
      <div>
        <img className="okul-yonetim-success-img" src={okulSepetiPopUp} alt="success" />
        <div className="okulyonetim-add-to-class-modal">
          <div className="okulyonetim-add-to-class-modal-info">
            <img src={image} alt="" />
            <div className="okulyonetim-add-to-class-modal-info-text">
              <div className="okulyonetim-add-to-class-modal-info-text-title">{title}</div>
              <div className="okulyonetim-add-to-class-modal-info-text-price">{price} TL</div>
            </div>
          </div>
        </div>
        {dersler.length > 0 && <Table dataSource={data} columns={columns} pagination={false} />}
      </div>
    </Modal>
  )
}

export default OkultonetimSuccessModal
